import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { GdprRequestEffects } from './gdpr-request.effects';
import { GdprRequestNamespace, GdprRequestReducer } from './gdpr-request.store';

@NgModule({
  imports: [
    StoreModule.forFeature(GdprRequestNamespace, GdprRequestReducer),
    EffectsModule.forFeature([GdprRequestEffects]),
  ],
})
export class GdprRequestDataModule {}
